<template>
  <v-sheet max-width="380" class="mx-auto" color="transparent">
    <v-form
      @submit.prevent="$v.$invalid ? null : submit()"
      ref="form"
      class="my-10"
    >
      <v-text-field
        :error-messages="fieldErrors('email').length>0?$t(page+'.'+fieldErrors('email')):null"
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
        @focus="message='';email=''"
        prepend-inner-icon="email"
        v-model="email"
        label="Email"
        outlined
        color="info"
      />

        <v-btn block color="info" type="submit" :disabled="$v.$invalid" :loading="loader"
          >{{$t(page+'.Get OTP')}}</v-btn
        >
        <v-alert
        v-if="message"
        type="error"
        dark
        dense
        dismissible
        class="mt-4"
      >
        {{message}}
      </v-alert>
    </v-form>
    <v-row class="ma-0">
      <v-col cols="6" md="6" class="pa-0">
        <div class="text-left my-1">
          <router-link
            to="/auth/signup"
            class="py-1 no-text-decoration info--text"
            >{{$t(page+'.Create Account')}}</router-link
          >
        </div>
      </v-col>
      <v-col cols="6" md="6" class="pa-0">
        <div class="text-right my-1">
          <router-link
            to="/auth/login"
            class="py-1 no-text-decoration info--text"
            >{{$t(page+'.Sign In')}}
          </router-link>
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email },
  },
  validationMessages: {
    email: {
      required: 'Please enter email',
      email: 'Email must be valid',
    },
  },
  created(){
    const la=window.navigator.userLanguage||window.navigator.language;
    this.$store.dispatch("setLocale",la.substring(0,2));
    this.email=this.$route.query.email?this.$route.query.email:'';
    console.log(246,this.$route.query.email);    
  },  
  data() {
    return {
      page:'Auth',
      errors: null,
      email: null,
      loader: false,
      message:'',
    };
  },
  methods: {
    async submit() {
        this.loader=true;
        try{
          const res = await this.$http.post('/auth/sendotp.php', {"email":this.email})    
          if (res.data.errorid=='0'){
            this.$emit("next", { email: this.email });
            this.message=res.data.message;
          }
          else
          {
            this.message=res.data.message;
          }
      } catch(e)
      {
        let user2='{"errorid":"0003","message":"Email non censita","level":"6","active":"1","company":"xLogistics","email":"mail@jslab.it","landingpage":"dashboard","avatar":"/static/avatar/nir.jpg","subscriptionlevel":"0","subscriptionexpiry":"2021-01-31 00:00:00.000","credits":".0000","name":"Nir Erlich","currency":"ils","locale":"he"}';
        let user3=JSON.parse(user2);
        this.message=user3.message;
      }
      this.loader=false;
    },

    /*
    submit() {
      this.loader = true;
      setTimeout(() => {
        this.loader = false;
        this.$emit("next", { email: this.email });
      }, 2000);
    },
    */
  },
};
</script>
